export default __webpack_public_path__ + "static/pack-18eb44e8757cbc43acadcc4d8e62f09a.png";